import React from "react";
import { CommonProps } from "fds/src/helpers/props";
import "./index.scss";

export interface IProps extends CommonProps {
  width?: string | number | undefined;
  height?: string | number | undefined;
  direction?: "row" | "col";
}
const DividerIcon: React.FC<IProps> = ({
  classes,
  width,
  direction = "row",
  height,
}) => {
  return direction === "row" ? (
    <svg
      width={width || "24"}
      height={height || "2"}
      className={classes}
      viewBox="0 0 24 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H24" stroke="#E9ECEF" />
    </svg>
  ) : (
    <svg
      width={width || "2"}
      height={height || "24"}
      className={classes}
      viewBox="0 0 2 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 0L0.999999 24" stroke="#E9ECEF" />
    </svg>
  );
};

export default DividerIcon;
